var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94891 17.4949C10.2556 17.175 10.4277 16.7422 10.4277 16.2911C10.4277 15.84 10.2556 15.4072 9.94891 15.0873L4.1199 8.95731L9.94891 2.91269C10.2556 2.59276 10.4277 2.15999 10.4277 1.70888C10.4277 1.25778 10.2556 0.825007 9.94891 0.505082C9.79584 0.345039 9.61372 0.218008 9.41307 0.13132C9.21241 0.0446312 8.99719 1.70591e-08 8.77982 1.96512e-08C8.56244 2.22434e-08 8.34722 0.0446312 8.14657 0.13132C7.94591 0.218008 7.7638 0.345039 7.61072 0.505082L0.629084 7.74497C0.47475 7.90371 0.352251 8.09256 0.268655 8.30064C0.185059 8.50871 0.142018 8.7319 0.142018 8.95731C0.142018 9.18272 0.185059 9.40591 0.268655 9.61398C0.352251 9.82206 0.47475 10.0109 0.629084 10.1697L7.61072 17.4949C7.7638 17.655 7.94591 17.782 8.14657 17.8687C8.34722 17.9554 8.56244 18 8.77982 18C8.99719 18 9.21241 17.9554 9.41307 17.8687C9.61372 17.782 9.79584 17.655 9.94891 17.4949Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/go-back.2e29ab03a38fabac818963ef02f9f081.svg";
export { ForwardRef as ReactComponent };